// extracted by mini-css-extract-plugin
export default {"layout":"_Q9YUkjGCGypy8g9-Ff4h"};